import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KbNotificationsService {

  constructor(protected occEndpointsService: OccEndpointsService, protected http: HttpClient) { }
  private popupVisible = new BehaviorSubject<boolean>(false);
  popupVisible$ = this.popupVisible.asObservable();

  getNotificationCount() {
    return this.http.get(this.occEndpointsService.buildUrl(`notifcation/getNotificationCount`));
  }
  getNotifications() {
    return this.http.get(this.occEndpointsService.buildUrl(`notifcation/getNotifications`));
  }
  deleteNotification(notificationCode){
    return this.http.post(this.occEndpointsService.buildUrl(`notifcation/updateNotification?notificationCode=${notificationCode}`),null);
  }
}
